import { prefixObjectValues as pre } from '../../utils';
const prefix = 'education-view';
const table = pre(
  {
    addBtn: 'add-btn',
    emptyState: 'empty-state',
  },
  prefix
);

export default table;
